import { atom } from "recoil";

export const openConfirmTerms = atom ({
    key: "openConfirmTerms",
    default: false,
});